export default "__VITE_ASSET__CZY1TpJ9__"